/**
 * rtc加入返回值code枚举
 */
export enum RTCJoinedInfoCodeEnum {
  /**
   * 成功
   */
  Success = 0,
  /**
   * 失败
   */
  Failure = 1,
  /**
   * 重复加入
   */
  ReJoin = 2,
  /**
   * 无麦克风权限
   */
  NoMicroPermission = 3,

  /**
   * 未知异常
   */
  Unknown = 500,
}

/**
 * 进入rtc房间的回调信息
 */
export interface RTCJoinedInfo {
  code: RTCJoinedInfoCodeEnum;
  message: string;
  userId?: string;
  roomId?: number;
  errInfo?: {
    errCode: number;
    errMsg: string;
  };
}
